import React, {Component} from 'react';
import {FadeIn} from 'animate-components';

const emails = [{
      icon: 'fa-envelope-o',
      email: 'nitihetemi@gmail.com'
   }
]

const professinalProfiles = [{
      icon: 'fa-linkedin',
      link: 'https://www.linkedin.com/in/arianit-hetemi-4088b4120/'
   }, {
      icon: 'fa-github',
      link: 'https://github.com/arianithetemi'
   }
];

const socialNet = [{
      icon: 'fa-facebook-official',
      link: 'https://www.facebook.com/nitihetemi'
   }, {
      icon: 'fa-instagram',
      link: 'https://www.instagram.com/arianithetemi/'
   }
];

class Contact extends Component {
   render() {
      return (
         <div className="main">
            <FadeIn duration="1.2s" timingFunction="ease-out">
               <div className="row">
                  <div className="col-md-3">
                     <h3 className="about-title">Email</h3>
                  </div>
                  <div className="col-md-9">
                     {emails.map((data, index) => {
                        const {icon, email} = data;
                        return (
                           <div key={index}>
                              <a className='contact-link' href={`mailto:${email}`}><i class={`fa ${icon}`} aria-hidden="true"></i> {email}</a>
                           </div>
                        )
                     })}
                  </div>
               </div>
               <hr />
               <div className="row">
                  <div className="col-md-3">
                     <h3 className="about-title">Professional Profiles</h3>
                  </div>
                  <div className="col-md-9">
                     {professinalProfiles.map((data, index) => {
                        const {icon, link} = data;
                        return (
                           <div key={index}>
                              <a target="_blank" className='contact-link' href={link}><i class={`fa ${icon}`} aria-hidden="true"></i> {link}</a>
                           </div>
                        )
                     })}
                  </div>
               </div>
               <hr />
               <div className="row">
                  <div className="col-md-3">
                     <h3 className="about-title">Social Networks</h3>
                  </div>
                  <div className="col-md-9">
                     {socialNet.map((data, index) => {
                        const {icon, link} = data;
                        return (
                           <div key={index}>
                              <a target="_blank" className='contact-link' href={link}><i class={`fa ${icon}`} aria-hidden="true"></i> {link}</a>
                           </div>
                        )
                     })}
                  </div>
               </div>
            </FadeIn>
         </div>
      );
   }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js